var map = {
	"./lalbaug (14).jpg": 2625,
	"./lalbaug (18).jpg": 6397,
	"./lalbaug (2).jpg": 5410,
	"./lalbaug (5).jpg": 8883,
	"./lalbaug (7).jpg": 6745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6565;